import { lazy } from 'react';
import { IA_KEY } from 'helpers/ia-logic';

import {
  watchActions as watchCampaignsActions,
  handleRouteEnter,
  handleRootRouteEnter,
  handleEditRouteEnter,
} from './Campaigns.saga';

const CampaignsAdd = lazy(() => import(/* webpackChunkName: "campaigns-add" */ './CampaignsAddContainer'));
const CampaignsEdit = lazy(() => import(/* webpackChunkName: "campaigns-edit" */ './CampaignsEditContainer'));
const Campaigns = lazy(() => import(/* webpackChunkName: "campaigns" */ './Campaigns'));

export default [
  {
    path: '/campaigns/:venueId/add',
    component: CampaignsAdd,
    iaKey: IA_KEY.CAMPAIGNS,
    pathSagas: [watchCampaignsActions, handleRouteEnter],
    locationSagas: [],
  },
  {
    path: '/campaigns/:venueId/:partnerCampaignId/edit',
    component: CampaignsEdit,
    iaKey: IA_KEY.CAMPAIGNS,
    pathSagas: [watchCampaignsActions, handleEditRouteEnter],
    locationSagas: [],
  },
  {
    path: '/campaigns/:venueId?',
    component: Campaigns,
    iaKey: IA_KEY.CAMPAIGNS,
    pathSagas: [watchCampaignsActions, handleRouteEnter, handleRootRouteEnter],
    locationSagas: [],
  },
];
